import { SocketIoProvider } from './socket-io.provider';
import { OldSignalRProvider } from './old-signalr.provider';
import { SignalR } from 'ng2-signalr';
import { MsgBusProvider, MsgBusProviderName } from './msg-bus-provider';
import { Injectable, InjectionToken } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class MsgBusFactoryService {
    constructor(private _signalR: SignalR){}
    
    create(providerName: MsgBusProviderName): MsgBusProvider{
        switch (providerName){
            case "signalR":
                return new OldSignalRProvider(this._signalR);
            case "socketIO":
                return new SocketIoProvider();
        }
    }
}